import { amplitudeLib } from 'freedom-shared';

import {
  mainPageOpen,
  submitSearchForm,
  switchCitiesClick,
  blogClick,
  ticketPageClick,
  mainScroll,
  multiTripToggleClick,
  multiTripAutoExit,
  multiTripInfoOpen,
  multiTripSubmitValidationFailed,
  getMainPageVariant,
  aiChatOpen,
} from './main-page';
import {
  searchPageOpen,
  priceCalendarClick,
  filtersClick,
  resetFiltersClick,
  applyFiltersClick,
  sortSeparateClick,
  airlinesSeparateClick,
  timeSeparateClick,
  transfersSeparateClick,
  airlinesSeparateApplied,
  timeSeparateApplied,
  transfersSeparateApplied,
  changeSortMode,
  directFlightsClick,
  directFlightsShowMore,
  directFlightsView,
  openChangeSearchParams,
  priceCalendarShow,
  priceSwipeRight,
  priceSwipeLeft,
  priceCalendarClose,
  priceCalendarOffersShow,
  serpScroll,
  promocodeApplied,
  shareButtonClicked,
  searchResultCardCashbackPriceClick,
} from './search-page';
import {
  quizBannerClick,
  quizPageViewed,
  quizQuestion,
  quizNextQuestion,
  quizFinal,
  takePromocodeClick,
  otherRoutesClick,
} from './quiz';
import {
  detailsPageOpen,
  detailsPageContinue,
  jjDetailsBannerShow,
} from './details-page';
import {
  bookingSuccess,
  bookingError,
  productsPageOpen,
} from './products-page';
import { continueFareFamily, selectFareFamily } from './fare-family';
import {
  hotOffersAllDatesClick,
  hotOffersOriginCityChange,
  hotOffersScroll,
  hotOffersSearchClick,
  hotOffersPageOpen,
} from './hot-offers';
import {
  trySubmitPassengersData,
  selectSavedPassenger,
  savedPaxListOpen,
  savedPaxEditClick,
  savedPaxSaveClick,
  addNewPaxClick,
} from './passenger-data-page';
import {
  specialOffersBannerOpened,
  allSpecialOffersPageOpened,
  specialOffersClicked,
  specialOfferFriendsShown,
  specialOfferFriendsClicked,
} from './special-offers';
import {
  lastSearchesShow,
  lastSearchesClick,
  lastSearchesRemove,
} from './recent-searches';
import {
  mainTabClicked,
  favoritesTabClicked,
  ordersTabClicked,
  profileTabClicked,
} from './bottom-nav';
import {
  addToFavorites,
  removeFromFavorites,
  favoritesPageOpen,
  favoritesDirectionOpen,
  favoritesOfferClick,
  favoritesSearchClick,
} from './favorites';
import {
  quickBookingAssigned,
  quickBookingPageOpen,
  quickBookingPassengerSaved,
  quickBookingSeatSelected,
  quickBookingPayClick,
  quickBookingFallback,
  type QuickBookingFlow,
} from './quick-booking';
import {
  animatedFlowAssigned,
  animatedFlowFieldOpen,
  animatedFlowFieldCommit,
  animatedFlowDismissed,
} from './animated-flow';
import {
  recommendedOffersShown,
  recommendedOffersTriggerClick,
  recommendedOffersTeaserClick,
  recommendedOffersListItemClick,
} from './recommended-offers';

export type {
  MultiTripToggleDirection,
  MultiTripValidationErrorCode,
  MainPageVariant,
} from './main-page';

export type {
  AnimatedFlowField,
  AnimatedFlowFieldOpenTrigger,
} from './animated-flow';

const paymentClick = (
  promocodeSum?: string | null,
  isCharter?: boolean,
  flow: QuickBookingFlow = 'classic',
) => {
  amplitudeLib.logEvent('avfree_payment_click', {
    promocode_sum: promocodeSum,
    is_charter: isCharter,
    main_page_variant: getMainPageVariant(),
    flow,
  });
};

export const amplitudeEventsLib = {
  mainPageOpen,
  aiChatOpen,
  submitSearchForm,
  searchPageOpen,
  detailsPageOpen,
  detailsPageContinue,
  jjDetailsBannerShow,
  selectFareFamily,
  continueFareFamily,
  selectSavedPassenger,
  trySubmitPassengersData,
  bookingError,
  bookingSuccess,
  hotOffersAllDatesClick,
  hotOffersOriginCityChange,
  hotOffersScroll,
  hotOffersPageOpen,
  hotOffersSearchClick,
  changeSortMode,
  switchCitiesClick,
  blogClick,
  priceCalendarClick,
  filtersClick,
  resetFiltersClick,
  applyFiltersClick,
  sortSeparateClick,
  airlinesSeparateClick,
  timeSeparateClick,
  transfersSeparateClick,
  airlinesSeparateApplied,
  timeSeparateApplied,
  transfersSeparateApplied,
  savedPaxListOpen,
  savedPaxEditClick,
  savedPaxSaveClick,
  addNewPaxClick,
  productsPageOpen,
  paymentClick,
  specialOffersBannerOpened,
  allSpecialOffersPageOpened,
  specialOffersClicked,
  specialOfferFriendsShown,
  specialOfferFriendsClicked,
  ticketPageClick,
  quizBannerClick,
  quizPageViewed,
  quizQuestion,
  quizNextQuestion,
  quizFinal,
  takePromocodeClick,
  otherRoutesClick,
  directFlightsClick,
  directFlightsShowMore,
  directFlightsView,
  openChangeSearchParams,
  priceCalendarShow,
  priceSwipeRight,
  priceSwipeLeft,
  priceCalendarClose,
  priceCalendarOffersShow,
  serpScroll,
  promocodeApplied,
  lastSearchesShow,
  lastSearchesClick,
  lastSearchesRemove,
  shareButtonClicked,
  searchResultCardCashbackPriceClick,
  mainScroll,
  addToFavorites,
  removeFromFavorites,
  favoritesPageOpen,
  favoritesDirectionOpen,
  favoritesOfferClick,
  favoritesSearchClick,
  mainTabClicked,
  favoritesTabClicked,
  ordersTabClicked,
  profileTabClicked,
  multiTripToggleClick,
  multiTripAutoExit,
  multiTripInfoOpen,
  multiTripSubmitValidationFailed,
  quickBookingAssigned,
  quickBookingPageOpen,
  quickBookingPassengerSaved,
  quickBookingSeatSelected,
  quickBookingPayClick,
  quickBookingFallback,
  animatedFlowAssigned,
  animatedFlowFieldOpen,
  animatedFlowFieldCommit,
  animatedFlowDismissed,
  recommendedOffersShown,
  recommendedOffersTriggerClick,
  recommendedOffersTeaserClick,
  recommendedOffersListItemClick,
};
